import {
  VinoDataImage,
  generateStorefrontImage,
} from "../utils/generate-storefront-image";

import { Banner } from "../components/banner";
import { LinkTo } from "../types";

interface ContentfulBannerProps {
  __typename?: string;
  bannerTitle?: string;
  htmlBannerTitle?: string;
  bodyText?: string;
  tagline?: string;
  bodyTextColor?: string;
  titleColor?: string;
  hero?: boolean;
  contentPosition?: "Left" | "Center" | "Right";
  backgroundImage?: VinoDataImage;
  backgroundImageMedium?: VinoDataImage;
  backgroundImageSmall?: VinoDataImage;
  primaryCta: {
    buttonColour: string;
    buttonBorderColor: string;
    buttonTextColor: string;
    buttonHoverBorderColor?: string;
    buttonHoverBackgroundColor?: string;
    buttonHoverTextColor?: string;
    label: string;
    linkTo: LinkTo;
  };
}

const test = ({ __typename }: { __typename: string }): boolean =>
  __typename === "VinoData_Banner";

const create = (
  data: ContentfulBannerProps & { __typename?: string }
): JSX.Element => {
  const transformedData = {
    ...data,
    backgroundImage: generateStorefrontImage(data.backgroundImage),
    backgroundImageMedium: data.backgroundImageMedium
      ? generateStorefrontImage(data.backgroundImageMedium)
      : null,
    backgroundImageSmall: data.backgroundImageSmall
      ? generateStorefrontImage(data.backgroundImageSmall)
      : null,
  };

  return <Banner {...transformedData} />;
};

export default { test, create };
